import React from 'react';
import { useCustomerTransactions } from '@/api/transactions/use-transactions';
import { useCrmTrades } from '@/api/trades/use-trades';
import { useCustomer } from '@/api/customers/use-customers.tsx';
import { StatementDownloadButtonUI } from './StatementDownloadButton';
import type { StatementCustomer } from '@/types/statement';

interface CrmStatementDownloadButtonProps {
    customerId: string;
    variant?: 'mobile' | 'desktop';
    className?: string;
}

/**
 * CRM statement download for a specific customer. Uses CRM API only
 * (useCustomerTransactions, useCrmTrades, useCustomer). Use in CRM context only.
 */
const CrmStatementDownloadButton: React.FC<CrmStatementDownloadButtonProps> = ({
    customerId,
    variant = 'desktop',
    className = '',
}) => {
    const { data: customerResponse } = useCustomer(customerId);
    const { data: transactionsData, isLoading: transactionsLoading } = useCustomerTransactions(
        customerId,
        { per_page: 10000, status: 'completed' }
    );
    const { data: tradesData, isLoading: tradesLoading } = useCrmTrades({
        customerId,
        status: 'closed',
        per_page: 10000,
    });

    const transactions = transactionsData?.data ?? [];
    const trades = tradesData?.trades ?? [];
    const customer = customerResponse?.data;
    const customerProfile: StatementCustomer | undefined = customer
        ? {
              name: customer.name ?? '',
              customer_number: customer.customer_number ?? '',
              email: customer.email ?? '',
          }
        : undefined;
    const isLoading = transactionsLoading || tradesLoading;

    return (
        <StatementDownloadButtonUI
            transactions={transactions}
            trades={trades}
            customerProfile={customerProfile}
            isLoading={isLoading}
            variant={variant}
            className={className}
        />
    );
};

export default CrmStatementDownloadButton;
